import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";
import {AUTH_TIPE} from "../constants/AuthConstant";

const  shiftService = {}

shiftService.data = function (token,data='') {
    console.log(data.view)
    let url;
    if (data.view==='CALENDAR'){
        url='/transaksi/shift/show'
    }else{
        url='/transaksi/shift/data'
    }
    return fetch({
        url: url,
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

shiftService.data_import = function (token,data) {
    return fetch({
        url: '/transaksi/shift/data_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

shiftService.empty_import = function (token,data) {
    return fetch({
        url: '/transaksi/shift/empty_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

shiftService.save_import = function (token,data) {
    return fetch({
        url: '/transaksi/shift/save_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}


export default shiftService;
